import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-how-to-steps',
  templateUrl: './how-to-steps.component.html',
  styleUrls: ['./how-to-steps.component.scss']
})
export class HowToStepsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
